import { render, staticRenderFns } from "./SingleChef.vue?vue&type=template&id=12d73aab&scoped=true"
import script from "./SingleChef.vue?vue&type=script&lang=js"
export * from "./SingleChef.vue?vue&type=script&lang=js"
import style0 from "./SingleChef.vue?vue&type=style&index=0&id=12d73aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d73aab",
  null
  
)

export default component.exports